import React, { useState } from 'react';
import ConnectionsUpload from './ConnectionsUpload';
import SearchFilters from './SearchFilters';
import WaitlistFeatureButton from './WaitlistFeatureButton';

const FileUploadSection = ({ onUploadComplete, apiUrl }) => {
  const [filters, setFilters] = useState({
    location: 'India',
    job_title: ''
  });

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters({
      ...filters,
      [name]: value
    });
  };

  return (
    <div>
      <SearchFilters filters={filters} handleFilterChange={handleFilterChange} />
      {/* <div className="upload-section">
        <ConnectionsUpload onUploadComplete={onUploadComplete} filters={filters} apiUrl={apiUrl} />
      </div> */}

        <WaitlistFeatureButton />
    </div>
  );
};

export default FileUploadSection;